const isIframe = code => /(?:<iframe[^>]*)(?:(?:\/>)|(?:>.*?<\/iframe>))/.test(code);

export default isIframe;
